import { formatNumberDigit } from "~/utils/numberFormat";

const DASHBOARD_MASKED_MONEY = "x,xxx";

// Shared masked-money placeholder — use this everywhere (on-screen + print) so the
// hidden-cashier display stays consistent.
export const MASKED_MONEY = DASHBOARD_MASKED_MONEY;

// Non-reactive check for the HideCashier flag. Use inside plain (non-component)
// code such as the thermal print builders, which cannot consume the composable's
// reactive `shouldMaskMoney`. Pinia stores resolve fine outside components at
// print time, so this can read the current employee directly.
export const isMoneyMasked = (): boolean => {
  return usePosEmployeesStore().getCurrentEmployee?.HideCashier === true;
};

export const useDashboardMoneyMask = () => {
  const employeeStore = usePosEmployeesStore();

  const shouldMaskMoney = computed(() => {
    return employeeStore.getCurrentEmployee?.HideCashier === true;
  });

  const formatMoney = (value: number | string | null | undefined, digits = 2) => {
    if (shouldMaskMoney.value) {
      return DASHBOARD_MASKED_MONEY;
    }

    return formatNumberDigit(Number(value ?? 0), digits);
  };

  const formatFixed = (value: number | string | null | undefined, digits = 2) => {
    if (shouldMaskMoney.value) {
      return DASHBOARD_MASKED_MONEY;
    }

    return Number(value ?? 0).toFixed(digits);
  };

  return {
    shouldMaskMoney,
    maskedMoney: DASHBOARD_MASKED_MONEY,
    formatMoney,
    formatFixed,
  };
};
